import { BreakpointWidths } from '@pelotoncycle/design-system';
import React from 'react';
import styled from 'styled-components';
import { toCloudinarySrc } from '@peloton/images/toCloudinarySrc';
import { useCopy } from '../../copy';
import { BackgroundWidths } from '../ui/presets';

type GradientBackgroundProps = { mobileUrl: string; desktopUrl: string };

const StyledGradientBackground = styled.section<GradientBackgroundProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  height: auto;
  background-color: #0f101a;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props: GradientBackgroundProps) =>
    toCloudinarySrc({ src: props.mobileUrl, width: BackgroundWidths.mobile })});
  @media (min-width: ${BreakpointWidths.desktop}px) {
    background-image: url(${(props: GradientBackgroundProps) =>
      toCloudinarySrc({ src: props.desktopUrl, width: BackgroundWidths.desktop })});
  }
`;

export const GradientBackground: React.FC<React.PropsWithChildren> = ({ children }) => {
  const backgroundImageUrlMobile = useCopy(
    'remoteActivation.gradientBackgroundMobile',
  ) as string;
  const backgroundImageUrlDesktop = useCopy(
    'remoteActivation.gradientBackgroundDesktop',
  ) as string;

  return (
    <StyledGradientBackground
      mobileUrl={backgroundImageUrlMobile}
      desktopUrl={backgroundImageUrlDesktop}
      data-test-id="gradient-background"
    >
      {children}
    </StyledGradientBackground>
  );
};
